import { Form, Row, Col, Button, InputGroup } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'
import dataFile from '@components/data/datareading'
import Alert from '@group-devs/yfp7-global-modules/components/Alert'

const request = new Request(process.env.apiDomain)

function facebookDetails(props) {

    let contactAccount = props.contactAccount
    let facebook = typeof contactAccount != "undefined" && contactAccount.contact.socialSpace ? JSON.parse(contactAccount.contact.socialSpace.facebook) : {}
    
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [key, setKey] = useState(0);

    const [showUpdate, setShowUpdate] = useState(false);
    const [readOnly, setReadOnly] = useState(true);
    const [contactId, setContactId] = useState(null);
    const [data, setData] = useState({ 
        facebook_profile: null,
        facebook_page: null,
    })

    useEffect(() => {

        if(typeof contactAccount != 'undefined'){
            setData({ 
                facebook_profile: facebook ? facebook.profile : "",
                facebook_page: facebook ? facebook.page : "",
            })

            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount]);

    const onClickEdit = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(false)
    }

    const onClickCancel = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(true)
    }

    function handleChange(evt)
    {
        const value = evt.target.value;
        setData({
          ...data,
          [evt.target.name]: value
        });
    }

    async function handleSave(e)
    {
        console.log(data)
        let res = await request.contacts.updateSocialSpaces({...data, contact_id: contactId});
        if(res.err){
            console.log('error')
        }else{
            onSuccess('Successfully updated facebook details.');
            onClickCancel()
        }
    }

    const onSuccess = (message) => 
    {
        setSuccessMessage(message)
        setErrorMessage(''); // Clear error message if any
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }

    return (
        <div className="facebookDetails py-5 border-bottom">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <Alert key={key} successMessage={successMessage} errorMessage={errorMessage}/>
                    <p><strong>Facebook</strong></p>
                    <Form>
                        <Form.Group as={Row} controlId="formPlaintextFacebook">
                            <Form.Label column md="3" className="text-md-right">Personal Profile</Form.Label>
                            <Col md="7">
                                {/* <Form.Control type="text" className="rounded-0" defaultValue={facebook ? facebook.profile : ""} readOnly={readOnly}/> */}
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-fb" className="input-group-no-right-radius">facebook.com/</InputGroup.Text>
                                    <Form.Control aria-describedby="basic-fb" name="facebook_profile" onChange={handleChange} value={data.facebook_profile} readOnly={readOnly}/>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextFanPage">
                            <Form.Label column md="3" className="text-md-right">Fan Page</Form.Label>
                            <Col md="7">
                                {/* <Form.Control type="text" className="rounded-0" defaultValue={facebook ? facebook.page : ""} readOnly={readOnly}/> */}
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-fb-page" className="input-group-no-right-radius">facebook.com/</InputGroup.Text>
                                    <Form.Control aria-describedby="basic-fb-page" name="facebook_page" onChange={handleChange} value={data.facebook_page} readOnly={readOnly}/>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        {/* <Form.Group as={Row} controlId="formPlaintextGroup">
                            <Form.Label column md="3" className="text-md-right">Group</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" className="rounded-0 mb-4" defaultValue="https://www.facebook.com/group/samplegroup"/>
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill"><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group> */}
                        <Form.Group as={Row} controlId="formPlaintextGroup">
                            <Col md="3"></Col>
                            <Col md="7">
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill" onClick={handleSave}><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default facebookDetails
